import { useAnalytics } from "../../components";
import { UiWebinarLinkModel } from "../../models";

import { WebinarLink } from "./UiWebinarLink.styles";

export type UiWebinarLinkProps = {
    readonly model: UiWebinarLinkModel;
};

const UiWebinarLink = ({
    model: { type, content, id }
}: UiWebinarLinkProps) => {
    const { sendTrackEvent } = useAnalytics();
    return (
        <WebinarLink
            onClick={() =>
                sendTrackEvent("clickedUiWebinarLink", {
                    event: "clicked",
                    eventContainer: type,
                    eventComponent: "content",
                    label: content.title,
                    labelEnglish: content.entryTitle,
                    uuid: id,
                    href: content.url,
                    appearance: content.appearance
                })
            }
            href={content.url}
            appearance={content.appearance}
            target="_blank"
            data-uuid={id}
        >
            <span>{content.title}</span>
        </WebinarLink>
    );
};

export default UiWebinarLink;
